// Banco de Conteúdo Acadêmico 2026
export const ACADEMIC_CONTENT_2026 = [
  {
    id: "tradicional",
    label: "Abordagem Tradicional",
    categorias: [
      {
        titulo: "CLÍNICA MÉDICA: NEFROLOGIA E REUMATO",
        topicos: [
          "Introdução (Anatomia e Fisiologia)",
          "Doença dos Glomérulos (Nefrítica, Nefrótica, GNRP, SHU)",
          "Doenças Tubulointersticiais (NTA, NIA, NIC, Rabdomiólise)",
          "Doenças Vasculares Renais (Estenose, Ateroembolismo)",
          "Distúrbios Hidroeletrolíticos e Acidobásicos",
          "Insuficiência Renal (Aguda, Crônica e Diálise)",
          "Artrites (Reumatoide, Gotosa, Séptica, Osteoartrose)",
          "Colagenoses (Lúpus, SAF, Sjogren, Esclerose, Miopatias)",
          "Vasculites (Temporal, Takayasu, Kawasaki, Wegener, Behcet)",
          "Miscelânea (Febre Reumática, Fibromialgia, Amiloidose)"
        ]
      },
      {
        titulo: "CLÍNICA MÉDICA: HEMATO E HEPATO",
        topicos: [
          "Anemias Hipoproliferativas e Hiperproliferativas",
          "Leucemias (Agudas, Crônicas e Tricoleucemia)",
          "Linfomas e Mieloma Múltiplo",
          "Distúrbios da Hemostasia (Primária e Secundária)",
          "Hemotransfusão e Trombofilias",
          "Introdução à Hepatologia e Metabolismo da Bilirrubina",
          "Hepatites (Virais, Medicamentosa e Fulminante)",
          "Cirrose: Causas (Álcool, MALSD) e Consequências",
          "Transplante Hepático"
        ]
      },
      {
        titulo: "CLÍNICA MÉDICA: CARDIO E ENDÓCRINO",
        topicos: [
          "Arritmias (Taqui e Bradiarritmias)",
          "Insuficiência Cardíaca e Cardiomiopatias",
          "Pericardiopatias e Valvopatias",
          "HAS (Primária, Secundária e Crise)",
          "Doença Arterial Coronariana (Crônica e IAM)",
          "Doenças da Tireoide, Adrenal, Paratireoide e Hipófise",
          "Diabetes Mellitus (Tipos, Complicações Agudas e Crônicas)",
          "Dislipidemias e Metabolismo Ósseo"
        ]
      },
      {
        titulo: "CLÍNICA MÉDICA: PNEUMO, INFECTO E NEURO",
        topicos: [
          "Asma, DPOC e Fibrose Cística",
          "Pneumopatias Intersticiais e Tuberculose",
          "DVP, TEP e Hipertensão Pulmonar",
          "Pneumonias e Endocardite Infecciosa",
          "Meningites, ITU e Parasitoses Intestinais",
          "Síndromes Febris (Dengue, Zika, Chikungunya)",
          "AVE, Cefaleias e Trombose Venosa Central",
          "Síndrome Epiléptica e Fraqueza Muscular (Guillain-Barré, Miastenia)"
        ]
      },
      {
        titulo: "CIRURGIA GERAL E GASTRO",
        topicos: [
          "Trauma (XABCDE, Tórax, Abdome, TCE, Face, Cervical)",
          "Perioperatório (Pré, Intra e Pós-Operatório)",
          "Hérnias da Parede Abdominal",
          "Queimaduras",
          "Doenças do Esôfago, Estômago e Intestinos",
          "Obstrução Intestinal, Apendicite e Diverticulite",
          "Hemorragia Digestiva (Alta e Baixa)",
          "Doenças do Pâncreas e Vias Biliares"
        ]
      },
      {
        titulo: "GINECOLOGIA E OBSTETRÍCIA",
        topicos: [
          "Ciclo Menstrual, SOP e Amenorreia",
          "Anticoncepção, Infertilidade e Climatério",
          "Sangramentos Benignos, Endometriose e Dismenorreia",
          "Incontinência Urinária e Distopia Genital",
          "Mastologia e Oncologia Ginecológica",
          "ISTs e Violência Sexual",
          "Assistência Pré-Natal e Diagnóstico de Gravidez",
          "Mecanismo do Parto e Fórcipe",
          "Sangramentos na Gestação e Doença Hemolítica",
          "DHEG, Diabetes Gestacional e Sofrimento Fetal",
          "Puerpério Fisiológico e Patológico"
        ]
      },
      {
        titulo: "PEDIATRIA",
        topicos: [
          "Neonatologia (Reanimação, TORCHS, Icterícia, Exame Físico)",
          "Cardiopatias Congênitas e Tumores Abdominais",
          "Aleitamento, Crescimento e Desenvolvimento",
          "Desnutrição, Obesidade e Carências Vitamínicas",
          "Genética, Erros Inatos do Metabolismo e Puberdade",
          "Imunizações e Doenças Exantemáticas",
          "Diarreias, Constipação e Doenças Respiratórias (VAS/VAI)",
          "Trato Urinário, Alergia e Imunodeficiências"
        ]
      },
      {
        titulo: "MEDICINA PREVENTIVA",
        topicos: [
          "Medidas de Saúde Coletiva e Indicadores Demográficos",
          "Estudos Epidemiológicos e Estatística Básica",
          "Epidemiologia Clínica e Testes Diagnósticos",
          "Vigilância da Saúde e Processo Epidêmico",
          "Saúde do Trabalhador e Acidentes de Trabalho",
          "Ética Médica, Bioética e Declaração de Óbito",
          "Promoção à Saúde e História do SUS",
          "Atenção Básica, PNAB e Ferramentas de Família (SOAP/Genograma)"
        ]
      }
    ]
  },
  {
    id: "sindromica",
    label: "Abordagem Sindrômica",
    categorias: [
      {
        titulo: "SÍNDROME ICTÉRICA I e II",
        topicos: [
          "Classificação das Síndromes Ictéricas",
          "Distúrbios no Metabolismo da Bilirrubina (Rotor, Dubin-Johnson, C. Najjar)",
          "Hepatites (Virais, Autoimune, Medicamentosa, Fulminante)",
          "Colestases (Colangite Biliar Primária e Esclerosante)",
          "Colelitíase / Colecistite / Coledocolitíase",
          "Doença Hepática Alcoólica",
          "Síndrome de Mirizzi",
          "Videolaparoscopia e Lesão Iatrogênica de Via Biliar"
        ]
      },
      {
        titulo: "SÍNDROME DIARREICA",
        topicos: [
          "Classificação Temporal da Diarreia",
          "Gastroenterites Infecciosas",
          "Doença Celíaca e Doença de Whipple",
          "Supercrescimento Bacteriano e Colite Microscópica",
          "Parasitoses (Protozoários, Helmintos e Platelmintos)",
          "DII (Crohn e RCU)",
          "Síndrome do Intestino Irritável e Intolerância à Lactose"
        ]
      },
      {
        titulo: "SÍNDROME METABÓLICA E ENDÓCRINA",
        topicos: [
          "HAS (Primária, Secundária, Resistente e Crise)",
          "Diabetes Mellitus (DM1, DM2 e Complicações Agudas/Crônicas)",
          "Dislipidemia e Obesidade",
          "Distúrbios da Tireoide (Graves, Hashimoto, Tireoidites, Nódulos)",
          "Glândula Suprarrenal (Insuficiência, Cushing, Hiperaldo, Feo)",
          "Paratireoide e Metabolismo Ósseo (Raimitismo, Paget)",
          "Hipófise e Hipotálamo (Acromegalia, Prolactinoma)"
        ]
      },
      {
        titulo: "SÍNDROMES RESPIRATÓRIAS E INFECTO",
        topicos: [
          "Pneumonias (Comunitária, Nosocomial e PAVM)",
          "Grandes Síndromes Bacterianas (Endocardite, ITU, Abscesso Hepático)",
          "HIV/AIDS (Diagnóstico, Tratamento, PREP/PEP e Transmissão Vertical)",
          "Síndromes Febris (Arboviroses, Ictéricas e Calazar)",
          "Tosse Crônica (Tuberculose e Micoses Pulmonares)",
          "Síndrome Dispneica (TEP, Asma, DPOC, PID e HAP)"
        ]
      },
      {
        titulo: "SÍNDROMES NEUROLÓGICAS E MUSCULARES",
        topicos: [
          "Síndrome Neurovascular (AVE Isquêmico, Hemorrágico e Cruzada)",
          "Fraqueza Muscular (Polineuropatias, Miopatias e Distrofias)",
          "Síndrome Epiléptica e Crise Febril",
          "Cefaleias e Tumores do SNC",
          "Meningites e Abscesso Cerebral"
        ]
      },
      {
        titulo: "SÍNDROMES RENAIS E HEMATOLÓGICAS",
        topicos: [
          "Compartimentos Renais (Síndromes Glomerulares e Tubulointersticiais)",
          "Distúrbios Hidroeletrolíticos e Acidobásicos",
          "Síndrome Urêmica e Terapia de Substituição Renal",
          "Síndromes Anêmicas e Mieloma Múltiplo",
          "Pancitopenias e Leucemias",
          "Linfomas e Distúrbios da Hemostasia"
        ]
      },
      {
        titulo: "REUMATOLOGIA E IMUNOMEDIAÇÃO",
        topicos: [
          "Artrites, Fibromialgia e Policondrite",
          "Colagenoses (LES, SAF, Sjogren, Esclerose)",
          "Vasculites (Temporal, Kawasaki, Wegener, Behcet)",
          "Insuficiência Cardíaca e Cardiomiopatias",
          "Valvopatias e Doença Coronariana"
        ]
      },
      {
        titulo: "CIRURGIA E TRAUMA",
        topicos: [
          "Hipertensão-Porta e Insuficiência Hepática",
          "Disfagia e Dispepsia (DRGE, Úlcera, Esofagites)",
          "Hemorragia Digestiva (Alta, Baixa e Obscura)",
          "Abdome Agudo Clínico e Cirúrgico",
          "Obstrução Intestinal e Hérnias Abdominais",
          "Trauma I, II e III (ABCDE, Tórax, Abdome e TCE)",
          "Perioperatório e Queimaduras"
        ]
      },
      {
        titulo: "GINECOLOGIA E OBSTETRÍCIA",
        topicos: [
          "ISTs, Úlceras e Neoplasias Ginecológicas",
          "Ciclo Menstrual e Incontinência Urinária",
          "Amenorreia, SOP e Infertilidade",
          "Climatério e Osteoporose",
          "Sangramentos na Gestação e Doença Hemolítica",
          "DHEG, Diabetes Gestacional e Sofrimento Fetal",
          "Puerpério e Assistência ao Parto"
        ]
      },
      {
        titulo: "PEDIATRIA",
        topicos: [
          "Doenças Exantemáticas e Febre Sem Foco",
          "Trato Respiratório na Infância (VAS e VAI)",
          "Vacinação e Trato Urinário",
          "Neonatologia I, II e III (TORCHS, Reanimação, Cardiopatias)",
          "Crescimento, Puberdade e Desnutrição",
          "Aleitamento e Distúrbios TGI Pediátricos"
        ]
      },
      {
        titulo: "MEDICINA PREVENTIVA",
        topicos: [
          "SUS, Atenção Primária e ESF",
          "Princípios da MFC e Saúde Suplementar",
          "Epidemiologia e Testes Diagnósticos",
          "Bioestatística e Indicadores Demográficos",
          "Ética Médica, Vigilância e Declaração de Óbito",
          "Saúde do Trabalhador e Processo Epidêmico"
        ]
      }
    ]
  },
  {
    id: "subespecialidades",
    label: "Subespecialidades",
    categorias: [
      {
        titulo: "ANESTESIOLOGIA",
        topicos: [
          "Ventilação Mecânica / Drogas Anestésicas",
          "Técnicas Anestésicas (Local, Raqui/Peridural, Geral)",
          "Avaliação / Monitorização Anestésica",
          "Complicações Anestésicas"
        ]
      },
      {
        titulo: "TERAPIA INTENSIVA",
        topicos: [
          "Instabilidade Hemodinâmica / Choque (Tipos e Manejo)",
          "Sepse e Choque Séptico",
          "Alteração do Nível de Consciência",
          "Avaliação Pupilar e Reflexos de Tronco",
          "Morte Encefálica",
          "Insuficiência Respiratória / SDRA",
          "Infecção Relacionada a Cateter"
        ]
      },
      {
        titulo: "CIRURGIA VASCULAR",
        topicos: [
          "Aneurisma",
          "Dissecção Aguda de Aorta / Doença Arterial Periférica",
          "Oclusão Arterial Aguda de MMII / Doença Venosa Crônica"
        ]
      },
      {
        titulo: "CIRURGIA PEDIÁTRICA",
        topicos: [
          "Afecções Congênitas Cervicais (Cisto Dermoide, Higroma, Ducto Tireoglosso)",
          "Torcicolo Congênito",
          "Aparelho Digestivo (Atresia de Esôfago, Estenose de Piloro)",
          "Intestinos (Atresia, Má-rotação, Volvo, Íleo Meconial, Hirschprung)",
          "Enterocolite Necrosante / Invaginação Intestinal",
          "Divertículo de Meckel",
          "Vias Biliares (Cistos de Colédoco, Doença de Caroli)",
          "Hérnia Diafragmática Congênita",
          "Parede Abdominal (Gastrosquise, Onfalocele)",
          "Genitourinárias (Hidrocele, Criptorquidia, Fimose, Torções)",
          "Tumores Abdominais (Neuroblastoma, Wilms)",
          "Anomalias Anorretais"
        ]
      },
      {
        titulo: "ORTOPEDIA",
        topicos: [
          "Traumato-Ortopedia (Fraturas, Luxação, Entorse)",
          "Osteomielite",
          "Tumores Ósseos Primários (Osteossarcoma, Ewing)",
          "Ortopedia Pediátrica (Plexo Braquial, Displasia de Quadril, Legg-Calvé-Perthes)",
          "Epifisiólise / Doença de Osgood-Schlatter",
          "Doenças Periarticulares (Impacto, Epicondilites, Ligamentos)",
          "Lombalgia (Mecânica e Hérnia de Disco)"
        ]
      },
      {
        titulo: "OFTALMOLOGIA",
        topicos: [
          "Anatomia do Globo Ocular",
          "Retinopatia (Diabética e Hipertensiva)",
          "Glaucoma (Crônico e Agudo)",
          "Catarata",
          "Retinoblastoma",
          "Olho Vermelho (Conjuntivites, Esclerite, Úlcera de Córnea, Uveítes)",
          "Ametropias (Astigmatismo, Miopia, Estrabismo)"
        ]
      },
      {
        titulo: "OTORRINOLARINGOLOGIA",
        topicos: [
          "Vertigem (VPPB, Meniére, Neurite)",
          "Rinite Alérgica / Polipose Nasal",
          "Epistaxe",
          "Apneia do Sono (SAHOS)",
          "Disacusia",
          "Rouquidão / Câncer de Laringe"
        ]
      },
      {
        titulo: "PSIQUIATRIA",
        topicos: [
          "Distúrbios do Sono (Insônia, Narcolepsia, Parassonias)",
          "Delirium",
          "Dependência Química (Álcool, Opioides, Cocaína/Crack)",
          "Transtornos do Humor (Depressão, Bipolaridade, Distimia)",
          "Ansiedade (Pânico, TOC, TAG, Estresse Pós-Traumático)",
          "Transtornos Psicóticos (Esquizofrenia)",
          "Transtornos Alimentares (Anorexia, Bulimia)",
          "Suicídio",
          "Transtornos de Personalidade (Borderline, Antissocial, Narcisista)"
        ]
      },
      {
        titulo: "DERMATOLOGIA",
        topicos: [
          "Lesões Elementares",
          "Infectoparasitárias (Hanseníase, Leishmaniose, Micoses)",
          "Piodermites / Erisipela / Celulite",
          "Escabiose / Molusco / Herpes",
          "Farmacodermias (Urticária, Stevens-Johnson, DRESS)",
          "Eczemas (Atópico, Contato, Seborreica)",
          "Psoríase / Líquen Plano / Buloses",
          "Oncologia (CBC, CEC, Melanoma)",
          "Acne Vulgar"
        ]
      },
      {
        titulo: "PROCTOLOGIA",
        topicos: [
          "Hemorroidas",
          "Fissura Anal",
          "Abscesso e Fístula Anal",
          "Cisto Pilonidal"
        ]
      },
      {
        titulo: "GERIATRIA",
        topicos: [
          "Grandes Síndromes Geriátricas / Envelhecimento",
          "Avaliação Geriátrica Ampla (AGA)",
          "Demências (Alzheimer, Vascular, Lewy, Frontotemporal)",
          "Parkinsonismo",
          "Cuidados Paliativos"
        ]
      },
      {
        titulo: "UROLOGIA",
        topicos: [
          "Nefrolitíase / Hematúria",
          "Disfunção Erétil / Hipogonadismo",
          "Hiperplasia Prostática Benigna",
          "Onco-Urologia (Próstata, Bexiga, Testículo)"
        ]
      },
      {
        titulo: "CIRURGIA PLÁSTICA / CC PESCOÇO",
        topicos: [
          "Feridas (Fechamento, Enxerto, Retalho, LPP)",
          "Anatomia / Metástases Cervicais",
          "Câncer de Boca, Laringe e Glândulas Salivares",
          "Nódulo Cervical Suspeito"
        ]
      },
      {
        titulo: "INFECTO-BÔNUS",
        topicos: [
          "Emergentes (Covid-19, Monkeypox, Oropouche)",
          "Febrís (Tifoide, Malária, Maculosa, Lyme, Hantavirose)",
          "Mononucleose / Toxoplasmose / CMV",
          "Chagas / Arranhadura do Gato"
        ]
      },
      {
        titulo: "ONCOLOGIA GERAL",
        topicos: [
          "Pulmão (Nódulo Solitário, Carcinoma)",
          "Tireoide (Câncer e Nódulo)",
          "Gastrointestinal (Esôfago, Estômago, Linfoma, GIST)",
          "Colorretal / Poliposes / Síndrome de Lynch",
          "Pâncreas e Vias Biliares (Adenocarcinoma e Neuroendócrinos)",
          "Hepático (Adenoma, Hemangioma, HCC)",
          "Sarcomas e Partes Moles"
        ]
      },
      {
        titulo: "BÔNUS TOXICOLOGIA / CIRURGIA",
        topicos: [
          "Fios Cirúrgicos / Cicatrização / REMIT",
          "Intoxicações Exógenas",
          "Acidentes por Animais Peçonhentos"
        ]
      }
    ]
  }
];
